/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { AppThemeProvider } from "./theme/AppThemeProvider";
import { store } from "./store";
import { LicenseInfo } from "@mui/x-license-pro";
import "./index.css";
import "./theme/designSystem.css";

/*
  From: https://mui.com/r/x-license-key-installation

  License key security

  While we recommend hard-coding the license key in git, you can also use an
  environment variable to set the license key.

  The license key is checked without making any network requests—it's designed
  to be public. It's expected that the license key will be exposed in a JavaScript
  bundle; we simply ask licensed users not to actively publicize their license key.
*/

LicenseInfo.setLicenseKey("f8e53eadc3200c646c61beeebc4dd6e2Tz0xMjMwNTQsRT0xNzk3MDMzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// NOTE: Disable for now, we can enable later if neccessary
// reportWebVitals();
